import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { ACTIVE_BG_COLOR, ACTIVE_COLOR, DAY_HORIZONTAL_GAP_PX } from "./constants";

export default function RangeDay({ day, outsideCurrentMonth, draftRange, hasRange, ...other }) {
  const isStart = Boolean(draftRange.fromDate && day.isSame(draftRange.fromDate, "day"));
  const isEnd = Boolean(draftRange.toDate && day.isSame(draftRange.toDate, "day"));
  const isInRange = Boolean(hasRange && day.isAfter(draftRange.fromDate, "day") && day.isBefore(draftRange.toDate, "day"));
  const isRangeEdgeLeft = day.day() === 0;
  const isRangeEdgeRight = day.day() === 6;
  const isRangeVisible = !outsideCurrentMonth && (isInRange || isStart || isEnd);

  return (
    <PickersDay
      day={day}
      outsideCurrentMonth={outsideCurrentMonth}
      {...other}
      sx={{
        m: `0 ${DAY_HORIZONTAL_GAP_PX}px`,
        width: 36,
        height: 36,
        p: 0,
        position: "relative",
        zIndex: 1,
        ...(isRangeVisible && {
          "&::before": {
            content: '""',
            position: "absolute",
            top: 2,
            bottom: 2,
            left: isStart && !isRangeEdgeRight ? `calc(50% - ${DAY_HORIZONTAL_GAP_PX}px)` : `-${DAY_HORIZONTAL_GAP_PX}px`,
            right: isEnd && !isRangeEdgeLeft ? `calc(50% - ${DAY_HORIZONTAL_GAP_PX}px)` : `-${DAY_HORIZONTAL_GAP_PX}px`,
            backgroundColor: ACTIVE_BG_COLOR,
            borderTopLeftRadius: isStart || isRangeEdgeLeft ? 999 : 0,
            borderBottomLeftRadius: isStart || isRangeEdgeLeft ? 999 : 0,
            borderTopRightRadius: isEnd || isRangeEdgeRight ? 999 : 0,
            borderBottomRightRadius: isEnd || isRangeEdgeRight ? 999 : 0,
            zIndex: -1,
          },
        }),
        ...(isStart && {
          backgroundColor: ACTIVE_COLOR,
          color: "#fff",
          borderRadius: "50%",
          "&:hover, &:focus": { backgroundColor: ACTIVE_COLOR },
        }),
        ...(isEnd && {
          backgroundColor: ACTIVE_COLOR,
          color: "#fff",
          borderRadius: "50%",
          "&:hover, &:focus": { backgroundColor: ACTIVE_COLOR },
        }),
        ...(isStart &&
          isEnd && {
            borderRadius: "50%",
          }),
      }}
    />
  );
}

